import { render, staticRenderFns } from "./c-header-proposal.vue?vue&type=template&id=f5e36ac2&scoped=true&"
import script from "./c-header-proposal.vue?vue&type=script&lang=js&"
export * from "./c-header-proposal.vue?vue&type=script&lang=js&"
import style0 from "./c-header-proposal.vue?vue&type=style&index=0&id=f5e36ac2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e36ac2",
  null
  
)

export default component.exports